export enum RoundMode {
  None = 0,
  Nearest = 1,
  Floor = 2,
  Ceil = 3,
}
